import { render, staticRenderFns } from "./SideNavContent.vue?vue&type=template&id=2acae312"
import script from "./SideNavContent.vue?vue&type=script&lang=js"
export * from "./SideNavContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports